import * as React from "react";
import { connect } from "react-redux";
import { logUI } from '../../api/andyliticsApi';
import StatusBanner from '../common/StatusBanner';
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import AssessmentSuccessTile from './AssessmentSuccessTile';

class WellnessAssessmentSuccess extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        logUI("MBHWeb.UI.WellnessAssessmentSuccess.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { thriveDataPending, thriveData, thriveDataError } = this.props;
        const showScore = thriveData && !thriveDataError ? true : false;
        const score = showScore ? thriveData.overallScore : 0;
        const overallScoreColor = showScore ? thriveData.overallScoreColor : "#008fbe";
        const defaultScoreColor = "#008fbe";
        return (<div className="container-fluid body-content wellness-success-container">
            {thriveDataPending ? <Spinner /> :
                <React.Fragment>
                    <div className="row">
                        <div className="col-12">
                            <StatusBanner bannerAlignment="left" bannerMsg={`Your Well-being Assessment has been received.`} failedStatus={false} />
                        </div>
                    </div> 
                    <div className="row">
                        <div className="col-12 maxWidth-content confirmation-summary-container">                            
                            <AssessmentSuccessTile containerClass="wellness-survey-score" showScore={showScore} score={score} overallScoreColor={defaultScoreColor} linkText="View well-being Dashboard" linkLogAndylyticsText="MBHWeb.UI.WellnessAssessmentSuccess.Reports.Clicked" linkUrl="/wellbeingDashboard" cardHeading="Well-being Overall Score" subHeading="A full report has been posted to your Well-being Dashboard where you can view your Well-being scores, personal goals, and Action plan." />
                        </div>
                    </div>                        
                </React.Fragment>
            }
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        thriveData: state.thrive.card,
        thriveDataPending: state.thrive.cardPending,
        thriveDataSuccess: state.thrive.cardSuccess,
        thriveDataError: state.thrive.error ? true : false,
        token: state.domain.t
        //...ownProps
    };
};


const mapDispatchToProps = (dispatch) => {
    return {
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(WellnessAssessmentSuccess);